import React from "react"
import * as ReactDOM from "react-dom/client"
import reactToWebComponent from "react-to-webcomponent"
import { Quiz } from "./containers/Quiz"
import "./config/i18n.ts"

const HVACQuiz = reactToWebComponent(Quiz, React as any, ReactDOM as any, {
  props: ["language"],
})

customElements.define("hvac-quiz", HVACQuiz as any)
